import { Box, Button, Flex, HStack, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { useState } from 'react';

import { HIDE_SCROLLBAR } from '@styles/css-configs';
import { useUserStore } from '@store/app.store';
import { useInfiniteInitiatives } from '@services/query-services/initiatives.query-service';
import CenteredLayout from '@layouts/centered.layout';
import FeedScrollContainer from '@components/feed/feed-scroll-container.component';
import SummaryCardSkeleton from '@components/general/card/summary-card/summary-card-skeleton.component';
import CollectionCard from '@components/general/card/collection-card/collection-card.component';

const FILTER = {
  CREATOR: 'creator',
  COLLABORATOR: 'collaborator',
  TENANT: 'tenant'
};

export default function CollectionsPage() {
  const user = useUserStore((state) => state.user);
  const [filter, setFilter] = useState(FILTER.CREATOR);

  let filterParams = {};
  if (filter === FILTER.CREATOR) {
    filterParams = { creator_id: user?.id };
  } else if (filter === FILTER.COLLABORATOR) {
    filterParams = { collaborator_id: user?.id };
  }
  // else if (filter === FILTER.TENANT) {
  //   filterParams = { visibility: 'Tenant' };
  // }

  const infiniteCollectionsResult = useInfiniteInitiatives(
    {
      sort: 'updated_at',
      asc: false,
      pageSize: 8,
      type: 'Collection',
      has_archived_at: false,
      ...filterParams
    },
    {
      refetchOnMount: false
    }
  );

  return (
    <CenteredLayout>
      <Box p={11}>
        <HStack>
          <Text
            variant='page-header'
            data-testid='page-header'
          >
            Collections
          </Text>
        </HStack>
        <Flex py={8}>
          <TabButton
            isSelected={filter === FILTER.CREATOR}
            onClick={() => setFilter(FILTER.CREATOR)}
          >
            Your Collections
          </TabButton>
          <TabButton
            isSelected={filter === FILTER.COLLABORATOR}
            onClick={() => setFilter(FILTER.COLLABORATOR)}
          >
            Shared Collections
          </TabButton>
          {/* <TabButton
            isSelected={filter === FILTER.TENANT}
            onClick={() => setFilter(FILTER.TENANT)}
          >
            Other Collections
          </TabButton>*/}
        </Flex>
        <Stack gap={8}>
          <FeedScrollContainer
            grid
            gridProps={{
              columns: 2,
              gap: 6
            }}
            infiniteQueryResult={infiniteCollectionsResult}
            noResultsProps={{ mt: 6 }}
            loadingSkeleton={<FeedScrollSkeleton />}
            overflowY={{ base: 'unset', xl: 'scroll' }}
            sx={HIDE_SCROLLBAR}
            data-id='collections-feed'
          >
            {(page) =>
              (page?.data || []).map((collection) => (
                <CollectionCard
                  key={collection?.id}
                  collectionId={collection?.id}
                />
              ))
            }
          </FeedScrollContainer>
        </Stack>
      </Box>
    </CenteredLayout>
  );
}

const TabButton = ({ isSelected, onClick, children }) => {
  return (
    <Button
      onClick={onClick}
      flex={1}
      py={8}
      colorScheme='surface'
      variant='reskinGhost'
      rounded='none'
      border='0'
      position='relative'
      color={isSelected ? 'surface.onSurface' : 'surface.onSurfaceVariant'}
      fontWeight={500}
      _after={{
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: isSelected ? '2px' : '1px',
        bg: isSelected ? 'brandPrimary.primary' : 'surface.outlineVariant',
        pointerEvents: 'none'
      }}
    >
      {children}
    </Button>
  );
};

const FeedScrollSkeleton = () => {
  return (
    <SimpleGrid
      columns={2}
      gap={6}
    >
      <SummaryCardSkeleton />
      <SummaryCardSkeleton />
      <SummaryCardSkeleton />
      <SummaryCardSkeleton />
      <SummaryCardSkeleton />
      <SummaryCardSkeleton />
    </SimpleGrid>
  );
};
